/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {
	Component,
	Inject,
	OnInit,
	EventEmitter,
	Input,
	AfterContentChecked,
} from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialog,
	MatDialogRef,
} from "@angular/material/dialog";
import { SessionService } from "../../../platform/base/services/session.service";
import { Overlay } from "@angular/cdk/overlay";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BreakpointObserver } from "@angular/cdk/layout";
import { ActivatedRoute } from "@angular/router";

import { IErrorObject } from "../../../../../types/platform/universe";
import { DescriptionDialogComponent } from "../description-dialog/description-dialog.component";
import { YesNoDialogComponent } from "../../../platform/base/components/yes-no-dialog/yes-no-dialog.component";
import { ResponsiveWithUpdatableComponent } from "../../base/components/responsivewithupdatable.component";
import { Errors } from "../../base/library/errors";
import { MessageDialogComponent } from "../../base/components/message-dialog/message-dialog.component";
import { ShotdataDialogService } from "./shotdata-dialog.service";
import { IShotView } from "../../../../../types/aig/server";
import { TranslateService } from "@ngx-translate/core";

import _ from "lodash";

import { ShotdataService } from "./../shotdata.service";
import {
	calculatePartByMesure,
	mapData,
	updateModel,
	getDisplayPart,
} from "../../../utils/evaluationMethod";

/*
 *
 * */
@Component({
	selector: "aigia-shotdata-dialog-root",
	templateUrl: "./shotdata-dialog.component.html",
	styleUrls: ["./shotdata-dialog.component.css"],
})
export class ShotdataDialogComponent
	extends ResponsiveWithUpdatableComponent
	implements OnInit
{
	public device: string;
	public params: any = {};

	public _ = _;
	public showConfirmDialog = false;
	public dialogMemoAdvice: any = null;
	public calculateDiagnoseResult;
	public method: string = "AIGIA標準メソッド";
	public isRequestingAdvice = false;
	public shot: any = null;
	public updateShot = new EventEmitter<any>();
	public inputChange = new EventEmitter<any>();
	// public adviceCodePos = "-100px";

	@Input() public user: any;

	constructor(
		public matDialog: MatDialog,
		protected session: SessionService,
		protected overlay: Overlay,
		protected snackbar: MatSnackBar,
		protected breakpointObserver: BreakpointObserver,
		protected route: ActivatedRoute,
		@Inject(MAT_DIALOG_DATA)
		public data: any,
		public matDialogRef: MatDialogRef<ShotdataDialogComponent>,
		public shotDataDialogService: ShotdataDialogService,
		public translate: TranslateService,
		private shotsService: ShotdataService
	) {
		super(session, breakpointObserver, matDialog, translate);
		this.service = shotDataDialogService;
	}

	/**
	 * @returns none
	 */
	ngOnInit(): void {
		this.getSession((error: IErrorObject, session: object): void => {
			super.ngOnInit();

			this.user = this.data.user;
			this.method = this.data.method;
			this.shot = this.data.shot;

			this.device = "desktop";

			this.isHandsetPortrait.subscribe((layoutDetector: any) => {
				if (layoutDetector.matches) {
					this.device = "handset";
				}
			});

			this.isTabletPortrait.subscribe((layoutDetector: any) => {
				if (layoutDetector.matches) {
					this.device = "tablet";
				}
			});

			this.isWeb.subscribe((layoutDetector: any) => {
				if (layoutDetector.matches) {
					this.device = "desktop";
				}
			});

			this.calculateShotDataMethod();

			let self = this;
			this.inputChange.subscribe((data) => {
				console.log("inputChange", data);
				let { shot } = data;
				self.shot = shot;
				self.data.shot = shot;
				self.calculateShotDataMethod();

				if (
					_.get(shot, "request_advice.chatgpt.content", "") &&
					data.type != "save_memo"
				) {
					this.isRequestingAdvice = false;
					this.onViewAdvice();
				}
			});
		});
	}

	// ngAfterContentChecked() {
	// 	let el = document.getElementsByTagName("aigia-posture-tab");
	// 	if (el) {
	// 		let rect = el[0].getBoundingClientRect();
	// 		this.adviceCodePos = rect.width - 10 + "px";
	// 	}
	// }

	/**
	 *
	 */
	public cancel(): void {
		this.matDialogRef.close(null);
	}

	public isHasAdvice() {
		return _.get(this.data.shot, "request_advice");
	}

	protected errorDialog(
		error: IErrorObject,
		callback: (result: any) => void = (error: IErrorObject) => {}
	): void {
		if (error) {
			const dialog: MatDialogRef<any> = this.matDialog.open(
				MessageDialogComponent,
				{
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {
						content: {
							title: "Error.",
							message: error.message,
							tag: error.tag,
						},
					},
					disableClose: true,
				}
			);

			dialog.afterClosed().subscribe((result: any): void => {
				callback(result);
			});
		}
	}

	/**
	 * デリートダイアログ
	 * @param event
	 * @param id
	 */
	public onDelete(event: MouseEvent, id: string): void {
		const _delete = (id: string): void => {
			this.Progress(true);
			this.delete(id, (error: IErrorObject, result: any): void => {
				if (!error) {
					this.Complete("", result);
					this.data.isDelete = true;
					this.cancel();
				} else {
					this.Complete("error", error);
					this.errorDialog(
						Errors.generalError(error.code, error.message, "A2364")
					);
				}
				this.Progress(false);
			});
		};

		if (event.shiftKey) {
			// dialog?
			_delete(id);
		} else {
			const resultDialogContent: any = {
				title: this.translate.instant("ショット削除"),
				message: this.translate.instant(
					"このショットを削除してもよろしいですか？"
				),
				ok_button: this.translate.instant("はい"),
				cancel_button: this.translate.instant("いいえ"),
			};
			const dialog: MatDialogRef<any> = this.matDialog.open(
				YesNoDialogComponent,
				{
					width: "50%",
					minWidth: "320px",
					height: "fit-content",
					data: {
						session: this.currentSession,
						content: resultDialogContent,
					},
					disableClose: true,
				}
			);
			dialog.afterClosed().subscribe((result: object) => {
				if (result) {
					// if not cancel then
					_delete(id);
				}
			});
		}
	}

	public confirmToModel(data: any): any {
		return data;
	}

	public toListView(object: any): any {
		return object;
	}

	public toView(data: any): any {
		return data;
	}

	public calculateShotDataMethod() {
		this.calculateDiagnoseResult = calculatePartByMesure({
			method: this.method,
			input: this.shot,
			pro: null,
			csvData: null,
			user: _.get(this.session, "cache"),
		});
		console.log(
			"calculateShotDataMethod",
			this.method,
			this.shot,
			this.calculateDiagnoseResult
		);
	}

	public confirmSendAdviceRequest() {
		this.showConfirmDialog = true;
	}

	public agreeSendAdviceRequest() {
		this.showConfirmDialog = false;
		this.sendAdviceRequest();
	}
	public cancelSendAdviceRequest() {
		this.showConfirmDialog = false;
	}

	public sendAdviceRequest() {
		console.log("sendAdviceRequest");
		this.isRequestingAdvice = true;
		this.shotsService.shotRequestAdvice(
			{
				advice: this.calculateDiagnoseResult.allTemplateAdvice[0],
				shot: {
					..._.pick(this.calculateDiagnoseResult.input, [
						"_id",
						"user_id",
					]),
				},
			},
			(error, data) => {
				console.log(
					"sendAdviceResponse",
					JSON.stringify(data, null, 3)
				);

				if (data.value.code) {
					this.errorDialog(data.value);
					this.isRequestingAdvice = false;
				} else {
					let { isUpdate } = data.value;
					this.updateShot.emit({
						isUpdate,
						data,
						type: "send_advice",
					});
				}
			}
		);
	}
	public saveShotMemo({ shot_id, memo }, callback) {
		console.log("saveShotMemo");
		this.shotsService.shotDemo(
			{
				shot_id,
				memo,
			},
			(error, data) => {
				if (data.value.code) {
					this.errorDialog(data.value);
				} else {
					callback(data);
				}
			}
		);
	}

	public onViewAdvice() {
		if (this.dialogMemoAdvice) {
			this.dialogMemoAdvice.close(null);
		}
		const dialog: MatDialogRef<any> = this.matDialog.open(
			DescriptionDialogComponent,
			{
				width: `100%`,
				maxWidth: "100vw",
				height: "100svh",
				data: {
					calculateDiagnoseResult: this.calculateDiagnoseResult,
					shot: this.shot,
					ngStyle: {
						"z-index": 3,
					},
					locked: true,
					visible: true,
					view_mode: "advice",
					device: this.device,
				},
				panelClass: "custom-description-dialog-advice",
				disableClose: true,
			}
		);

		dialog.afterClosed().subscribe((result: any): void => {
			// this.Complete("", result);
		});

		this.dialogMemoAdvice = dialog;
	}

	public onViewMemo() {
		if (this.dialogMemoAdvice) {
			this.dialogMemoAdvice.close(null);
		}

		let safeAreaInsetBottom =
			parseFloat(
				getComputedStyle(document.documentElement).getPropertyValue(
					"--safe-area-inset-bottom"
				)
			) || 0;

		let heightMemo =
			Math.min(window.innerHeight - safeAreaInsetBottom, 300) + "px";

		const dialog: MatDialogRef<any> = this.matDialog.open(
			DescriptionDialogComponent,
			{
				width: `80%`,
				height: heightMemo,
				maxHeight: "100svh",
				maxWidth: "100vw",
				data: {
					calculateDiagnoseResult: this.calculateDiagnoseResult,
					shot: this.shot,
					size: [
						0.8 * window.innerWidth,
						(0.8 * window.innerWidth * 690) / 1150,
					],
					// position: { x: 60, y: 210 },
					ngStyle: { "z-index": 3 },
					locked: true,
					visible: true,
					view_mode: "memo",
					device: this.device,
				},
				panelClass: "custom-description-dialog-memo",
				disableClose: true,
			}
		);

		dialog.afterClosed().subscribe((result: any): void => {
			// this.Complete("", result);
		});

		let self = this;
		dialog.componentInstance.updateMemo.subscribe((msg) => {
			if (msg.type == "save_memo") {
				console.log("got message save_memo", msg);
				self.saveShotMemo(
					{
						shot_id: msg.data.calculateDiagnoseResult.input._id,
						memo: msg.data.memo,
					},
					(data) => {
						console.log("save shot memo callback", data);
						dialog.componentInstance.updateMemo.emit({
							type: "save_memo_success",
							data,
						});
						self.updateShot.emit({
							isUpdate: true,
							data,
							type: "save_memo",
						});
					}
				);
			}
		});
		this.dialogMemoAdvice = dialog;
	}

	public isAllowAdvice() {
		return !!_.get(
			this.calculateDiagnoseResult,
			"allTemplateAdvice.length"
		);
	}

	public handleRequestOrShowAdvice() {
		let isHasAdvice = _.get(this.shot, "request_advice");
		if (isHasAdvice) {
			this.onViewAdvice();
		} else if (this.isAllowAdvice() && !this.isRequestingAdvice) {
			this.confirmSendAdviceRequest();
		}
	}

	public isGottAdvice() {
		return !!_.get(this.calculateDiagnoseResult, "input.request_advice");
	}
}
